export default "__VITE_ASSET__DIJKwtlh__"